import { Button } from "antd";
import { GiftOutlined, SyncOutlined } from "@ant-design/icons";
import { BalanceCard } from "../components/TokenBalanceCard";
import PurchaseScratchCardModal from "./PurchaseScratchCardModal";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import userSelectors from "../../../store/user/selectors";
import { userActions } from "../../../store/user";

const PurchaseScratchCard = () => {
  const [visible, setVisible] = useState(false);
  const dispatch = useAppDispatch();

  return (
    <>
      <div className="purchase-scratch-card-box">
        <div className="purchase-scratch-img">
          <GiftOutlined style={{ fontSize: "52px", color: "#fff" }} />
        </div>
        <div className="purchase-scratch-card-btns">
        <Button
          className="purchase-scratch-card-btn"
          icon={<GiftOutlined />}
          onClick={() => setVisible(true)}
        >
          Buy Scratch Card
        </Button>
        <Button
          className="purchase-scratch-card-btn"
          icon={<SyncOutlined />}
          onClick={() => dispatch(userActions.getScratchCards())}
        >
          Fetch Cards
        </Button>
        </div>
      </div>
      <PurchaseScratchCardModal
        visible={visible}
        onClose={() => setVisible(false)}
      />
    </>
  );
};
const ScratchCardCount = () => {
  const scratchCards = useAppSelector(userSelectors.getScratchCards);
  return (
    <div className="scratch-card-summary">
      <h2 className="scratch-title">🎟️ Scratch Card Summary</h2>

      <div className="scratch-card-container">
        <div className="scratch-card-box scratched">
          <div className="scratch-number">{scratchCards.revealed}</div>
          <div className="scratch-label">Revealed Wins</div>
        </div>

        <div className="scratch-card-box to-scratch">
          <div className="scratch-number">{scratchCards.unrevaled}</div>
          <div className="scratch-label">Unrevealed Wins</div>
        </div>
      </div>
    </div>
  );
};

const ActionCards = () => {
  return (
    <>
      <div className="scratch-card-container">
        <div className="scratch-card-wrapper">
          <PurchaseScratchCard />
        </div>
        <div className="scratch-card-wrapper">
          <ScratchCardCount />
        </div>
        <div className="scratch-card-wrapper">
          <BalanceCard />
        </div>
      </div>
    </>
  );
};

export default ActionCards;
